import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import i18n from '@/settings/i18n';

export const useLocaleFromUrl = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLocaleProcessed = useRef(false);

  useEffect(() => {
    if (isLocaleProcessed.current) return;

    const searchParams = new URLSearchParams(location.search);
    const locale = searchParams.get('locale');

    if (locale) {
      isLocaleProcessed.current = true;
      i18n.changeLanguage(locale);
      searchParams.delete('locale');
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
        },
        { replace: true },
      );
    }
  }, [location.search, location.pathname, navigate]);
};
